import React, { useState, useEffect } from "react";
import s from "./PremiosPagados.module.css";

//assets
import Pager from "../../Shared/Pagination/Pagination";
import { Currency } from "../../../helpers/currencyConvert";
import FiltrosPremiosPagados from "./filters";
import exportToExcel from "../../../helpers/exportExcel";
import { formatJavaCompletoss } from "../../../config/strings";
import reportService from "../../../api/reports/reportsServices";
import { dateFormats } from "../../../helpers/convertDate";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material UI
import {
  Alert,
  CircularProgress,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Tooltip,
} from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import DescriptionIcon from "@mui/icons-material/Description";
import printTable from "../../../helpers/imprimir";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "0.9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const PremiosPagados = () => {
  const { t } = useTranslation();
  const dates = dateFormats();
  const [printing, setPrinting] = useState(false);
  const [completeReport, setCompleteReport] = useState([]);
  const { textColor } = useSelector((state) => state.local);
  const { currentLogo } = useSelector((state) => state.local);
  const [logo, setLogo] = useState("");

  //Estados
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [games, setGames] = useState([]);
  const [items, setItems] = useState([]);
  const [searching, setSearching] = useState(0);
  const [totalResults, setTotalResults] = useState(0);

  const [openError, setOpenError] = useState(false);

  //Filtros
  const [dateType, setDateType] = useState(0);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "id",
  });
  const [filters, setFilters] = useState({
    type: 0,
    typeAgency: 0,
    dateFrom: null,
    dateTo: null,
    agencyFrom: "",
    agencyTo: "",
    gameId: 0,
  });
  const [newFilters, setNewFilters] = useState({
    type: 0,
    typeAgency: 0,
    dateFrom: null,
    dateTo: null,
    agencyFrom: "",
    agencyTo: "",
    gameId: 0,
  });

  //Paginado
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  const handleExport = () => {
    let today = new Date();
    let toExport = completeReport.map((item) => ({
      Juego: item?.game?.name || "-",
      "Nro de Sorteo": item?.raffle?.number || "-",
      Serie: item?.raffle?.serie || "-",
      "Nro de Cupón": item?.couponNumber || "-",
      "Ag. Vendedora": item?.sellingAgencyNumber || "-",
      "Ag. Pagadora": item?.agencyNumber || "-",
      "Valor de Cupón": item?.paymentAmount || "-",
      "Fecha de Pago":
        dates.formatLocalDate(item?.paymentDate, formatJavaCompletoss) || "-",
      "Fecha de Caducidad":
        dates.formatLocalDate(
          item?.raffle?.expirationDate,
          formatJavaCompletoss,
        ) || "-",
    }));
    const typeName =
      filters.type === 0
        ? t("all")
        : filters.type === 1
          ? t("preprinted")
          : t("instant");
    exportToExcel(
      toExport,
      `${t("reportPrizesPaid")} ${typeName} - ${today.toISOString()}`,
    );
  };

  const handleSort = (name) => {
    setSort((prev) => ({
      criteria: prev.criteria === "ASC" ? "DESC" : "ASC",
      field: name,
    }));
  };

  const handleSearch = () => {
    setNewFilters(filters);
    setSearching((prev) => prev + 1);
    setPage(1);
  };

  const handleCleanFilters = () => {
    setFilters({
      type: 0,
      typeAgency: 0,
      dateFrom: null,
      dateTo: null,
      agencyFrom: "",
      agencyTo: "",
      gameId: 0,
    });
    setNewFilters({
      type: 0,
      typeAgency: 0,
      dateFrom: null,
      dateTo: null,
      agencyFrom: "",
      agencyTo: "",
      gameId: 0,
    });
    setPage(1);
    setTotalPages(1);
    setItems([]);
    setDateType(0);
    setSearching(0);
  };

  useEffect(() => {
    setLoading(true); //Loader
    reportService
      .getPaymentsPrizes(page, pageSize, sort, { ...newFilters, dateType }) //fetch de datos
      .then((res) => {
        setItems(res.content); //items
        setTotalPages(res.totalPages); //Total de paginas paginado
        setTotalResults(res.totalElements); //Total de elementos
        setLoading(false); //Loader
      })
      .catch((e) => {
        // Error
        console.log(e);
        setOpenError(true);
        setLoading(false);
      });
  }, [page, pageSize, sort, searching]);

  useEffect(() => {
    setLoadingReport(true);
    reportService
      .getAllPaymentsPrizes(sort, { ...newFilters, dateType }) //fetch de datos
      .then((res) => {
        setCompleteReport(res);
        setLoadingReport(false);
      })
      .catch((e) => {
        // Error
        setOpenError(true);
        setLoadingReport(false);
      });
  }, [sort, searching]);

  useEffect(() => {
    setLogo(currentLogo?.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    if (printing === true) {
      printTable(document.getElementById("prizes-table"));
      setPrinting(false);
    }
  }, [printing]);

  return (
    <>
      <Grid container className={s.container}>
        <Grid item xs={12} className={s.header}>
          <Grid item container xs={12} className={s.titleContainer}>
            <Grid
              item
              xs={11}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <PaidIcon
                sx={{ fontSize: "2rem", color: "primary.main", mr: 2 }}
              />
              <h4>{t("reportPrizesPaid")}</h4>
            </Grid>
          </Grid>
        </Grid>

        {loadingFilters ? (
          <Grid
            item
            xs={11}
            sx={{ display: "flex", alignItems: "center", mb: 3 }}
          >
            <CircularProgress />
            <p style={{ margin: 0, marginLeft: "20px" }}>
              {t("loadingFilter")}
            </p>
          </Grid>
        ) : (
          <>
            <FiltrosPremiosPagados
              searching={searching}
              handleSearch={handleSearch}
              handleCleanFilters={handleCleanFilters}
              dateType={dateType}
              setDateType={setDateType}
              filters={filters}
              setFilters={setFilters}
              setLoadingFilters={setLoadingFilters}
              games={games}
              setGames={setGames}
            />

            <Grid item xs={11} className={s.options}>
              <Grid item xs={6}>
                {loading ? (
                  <CircularProgress size="1.2rem" />
                ) : (
                  <p
                    style={{ fontSize: "1.2rem", margin: 0 }}
                  >{`${t("results")}: ${totalResults}`}</p>
                )}
              </Grid>

              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  size="small"
                  onClick={() => setPrinting(true)}
                  variant="contained"
                  sx={{ ml: 1 }}
                  disabled={!items?.length}
                >
                  <LocalPrintshopRoundedIcon
                    color={textColor}
                    sx={{ fontSize: "30px" }}
                  />
                  <p>{t("print")}</p>
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  disabled={!items?.length}
                  sx={{ ml: 1 }}
                  onClick={handleExport}
                >
                  <DescriptionIcon
                    color={textColor}
                    sx={{ fontSize: "30px" }}
                  />
                  <p>Excel</p>
                </Button>
              </Grid>
            </Grid>
          </>
        )}

        {loading || loadingFilters ? (
          <Grid item xs={12} className={s.loader}>
            <CircularProgress size={"4rem"} />
          </Grid>
        ) : (
          <Grid item container xs={12} className={s.data}>
            {items?.length ? (
              <Grid item xs={11} id="prizes-table">
                {printing ? (
                  <div className="logo">
                    <img src={logo} alt="logo" />
                  </div>
                ) : null}
                <TableContainer className={s.tableContainer}>
                  <Table className="print-table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            onClick={() => handleSort("id")}
                          >{`${t("game")} ${sort.field === "id" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            onClick={() => handleSort("raffleId")}
                          >{`${t("drawNumber")} ${sort.field === "raffleId" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            onClick={() => handleSort("agencyHolder")}
                          >{`${t("modality")} ${sort.field === "agencyHolder" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            className={s.tableHeader}
                            onClick={() => handleSort("couponNumber")}
                          >{`${t("couponNumber")} ${sort.field === "couponNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            onClick={() => handleSort("sellingAgencyId")}
                          >{`${t("sellingAgency")} ${sort.field === "sellingAgencyId" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            onClick={() => handleSort("sellingAgencyNumber")}
                          >{`${t("payingAgency")} ${sort.field === "sellingAgencyNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            className={s.tableHeader}
                            onClick={() => handleSort("paymentAmount")}
                          >{`${t("couponValue")} ${sort.field === "paymentAmount" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            className={s.tableHeader}
                            onClick={() => handleSort("paymentDate")}
                          >{`${t("paymentDate")} ${sort.field === "paymentDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                        <Tooltip title={t("sort")} placement="top-start">
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              cursor: "pointer",
                            }}
                            className={s.tableHeader}
                            onClick={() => handleSort("expirationDate")}
                          >{`${t("dateOfExpiry")} ${sort.field === "expirationDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                        </Tooltip>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {printing != true
                        ? items?.map((item, i) => (
                            <React.Fragment key={i}>
                              <TableRow
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "secondary.light",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.game?.name || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.raffle?.number || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.raffle?.serie || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.couponNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.sellingAgencyNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.agencyNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  <Currency value={item?.paymentAmount} />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {dates.formatDate(item?.paymentDate) ===
                                  "Invalid Date"
                                    ? "-"
                                    : dates.formatDate(item?.paymentDate)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {dates.formatDate(
                                    item?.raffle?.expirationDate,
                                  ) === "Invalid Date"
                                    ? "-"
                                    : dates.formatDate(
                                        item?.raffle?.expirationDate,
                                      )}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))
                        : completeReport?.map((item, i) => (
                            <React.Fragment key={i}>
                              <TableRow
                                key={i}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "secondary.light",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.game?.name || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.raffle?.number || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.raffle?.serie || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.couponNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.sellingAgencyNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item?.agencyNumber || "-"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  <Currency value={item?.paymentAmount} />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {dates.formatDate(item?.paymentDate) ===
                                  "Invalid Date"
                                    ? "-"
                                    : dates.formatDate(item?.paymentDate)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {dates.formatDate(
                                    item?.raffle?.expirationDate,
                                  ) === "Invalid Date"
                                    ? "-"
                                    : dates.formatDate(
                                        item?.raffle?.expirationDate,
                                      )}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))}
                    </TableBody>

                    {loadingReport ? (
                      <Grid
                        item
                        xs={11}
                        sx={{ display: "flex", alignItems: "center", mb: 3 }}
                      >
                        <CircularProgress />
                        <p style={{ margin: 0, marginLeft: "20px" }}>
                          {t("loadingFilter")}
                        </p>
                      </Grid>
                    ) : (
                      <TableBody>
                        <TableRow sx={{ backgroundColor: "white" }}>
                          <TableCell
                            sx={{ ...cellStyles, fontWeight: 800 }}
                            colSpan={3}
                          >
                            {t("totalCoupons")}
                          </TableCell>
                          <TableCell sx={{ ...cellStyles, fontWeight: 500 }}>
                            {completeReport?.length}
                          </TableCell>
                          <TableCell
                            sx={{ ...cellStyles, fontWeight: 800 }}
                            colSpan={2}
                          >
                            {t("totalAmount")}:{" "}
                          </TableCell>
                          <TableCell
                            sx={{ ...cellStyles, fontWeight: 500 }}
                            colSpan={3}
                          >
                            <Currency
                              value={completeReport?.reduce(
                                (acc, b) => acc + b?.paymentAmount,
                                0,
                              )}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  minHeight: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "1.8rem",
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 300,
                }}
              >
                {t("noResults")}
              </Grid>
            )}
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: "50px",
          }}
        >
          <Pager
            pageSize={pageSize}
            setPageSize={setPageSize}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            pageCustom={pageCustom}
            setPageCustom={setPageCustom}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </>
  );
};
